import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const { login, register, loginWithGoogle } = useAuth();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      if (isRegister) {
        await register(email, password);
        setSuccess('ההרשמה בוצעה בהצלחה! הנך מחובר כעת.');
      } else {
        await login(email, password);
      }
    } catch (err: any) {
      console.error(err);
      setError(err.message || 'אירעה שגיאה. אנא נסה שנית.');
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    try {
      await loginWithGoogle();
    } catch (err: any) {
      console.error(err);
      setError(err.message || 'אירעה שגיאה בחיבור עם גוגל.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 font-heebo select-none" dir="rtl">
      <div className="w-full max-w-md bg-white border border-solid border-black p-8 rounded-none shadow-none">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-black text-black tracking-tight uppercase border-b-2 border-solid border-black pb-2 inline-block">
            LINK2ME
          </h1>
          <p className="text-sm text-gray-500 mt-2 font-medium">
            ניהול קישורים ותיקיות חכם ונקי לצוותים
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-800 text-xs border border-solid border-red-400 font-bold rounded-none">
            {error}
          </div>
        )}

        {success && (
          <div className="mb-4 p-3 bg-green-100 text-green-800 text-xs border border-solid border-green-400 font-bold rounded-none">
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">
              אימייל:
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-solid border-black text-sm outline-none bg-white focus:bg-gray-50 focus:border-pink-500 rounded-none shadow-none"
              placeholder="name@company.com"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-700 mb-1">
              סיסמה:
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-solid border-black text-sm outline-none bg-white focus:bg-gray-50 focus:border-pink-500 rounded-none shadow-none"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-black hover:bg-gray-900 text-white font-bold text-sm border border-solid border-black hover:border-gray-900 transition-colors rounded-none shadow-none"
          >
            {isRegister ? 'הרשמה למערכת' : 'התחברות'}
          </button>
        </form>

        <div className="relative flex py-4 items-center">
          <div className="flex-grow border-t border-solid border-gray-300"></div>
          <span className="flex-shrink mx-4 text-xs font-bold text-gray-400">או</span>
          <div className="flex-grow border-t border-solid border-gray-300"></div>
        </div>

        <button
          onClick={handleGoogleLogin}
          type="button"
          className="w-full py-2 bg-white hover:bg-gray-50 text-black font-bold text-sm border border-solid border-black transition-colors flex items-center justify-center gap-2 rounded-none shadow-none"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="currentColor"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="currentColor"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
            />
            <path
              fill="currentColor"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
            />
          </svg>
          התחברות מהירה עם Google
        </button>

        <div className="mt-6 text-center">
          <button
            onClick={() => {
              setIsRegister(!isRegister);
              setError('');
              setSuccess('');
            }}
            className="text-xs font-bold text-gray-500 hover:text-black hover:underline"
          >
            {isRegister ? 'כבר יש לך חשבון? להתחברות' : 'אין לך חשבון עדיין? להרשמה'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;